import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Toaster from 'v-toaster';
import 'v-toaster/dist/v-toaster.css';
import router from './router'
import {
  EventBus
} from "./main";
Vue.use(Vuex)


export default new Vuex.Store({
  strict: true,
  state: {
    isLogin: !!window.localStorage.getItem('token'),
    idToken: window.localStorage.getItem('token'),
    user: window.localStorage.getItem('user'),
    token: window.localStorage.getItem('token') || '',
    status: '',
  },
  mutations: {
    authUser(state, userData) {
      let obj = {
        idToken: userData.token,
        token: userData.token,
        isLogin: true
      }
      return Object.assign(state, obj)
    },
    storeUser(state, user) {
      return {...state, user: user}
    },
    clearAuthData(state) {
      if ("fbUser" in window.localStorage) {

        let obj = {
          idToken: null,
          token: null,
          isLogin: false
        }
        Object.assign(state, obj)
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('expires_in')
        window.localStorage.removeItem('token_type')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('fbUser')
        window.localStorage.removeItem('role')
        window.localStorage.removeItem('URL')
        router.push('/global/signin')
      } else {
        let obj = {
          idToken: null,
          token: null,
          isLogin: false
        }
        Object.assign(state, obj)
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('expires_in')
        window.localStorage.removeItem('token_type')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('role')
        window.localStorage.removeItem('URL')

        router.push('/global/signin')
      }
    }
  },
  actions: {
    signup({commit,dispatch,state}, res) {
      window.localStorage.setItem('token', res.data.token)
      window.localStorage.setItem('expires_in', res.data.expires_in)
      window.localStorage.setItem('token_type', res.data.token_type)
      window.localStorage.setItem('role', res.data.role)
      window.localStorage.setItem('user', JSON.stringify(res.data.user))
      commit('authUser', {
        token: res.data.token,
        isLogin: true
      })
      commit('storeUser', res.data.user)
      EventBus.$emit("notificationCount",{id :0 , admin_mail: false});
      EventBus.$emit("role", window.localStorage.getItem('role'));
      if (window.localStorage.getItem('role') == 'engineer') {
        var data = JSON.parse(window.localStorage.getItem("user"));
        var userId = data.id;
        var userToken = data.user_token;
        var firstLogin = data.first_login;
        // if(data.nickname == null)
        // {
        //   router.replace("/engineer/nickname")
        // }
        if(firstLogin == 0)
        {
          EventBus.$emit("firstLogin",firstLogin)
          router.replace("/engineer/skill-update")
        }
        else{
          EventBus.$emit("firstLogin",firstLogin)
          if (window.localStorage.getItem('URL') == undefined) {
            router.push("/engineer/profile/" + userToken)
          } else {
            router.push(window.localStorage.getItem('URL') );
          }
        }
      }
    },
    login({commit,dispatch,state}, res) {
      window.localStorage.setItem('token', res.data.token)
      window.localStorage.setItem('expires_in', res.data.expires_in)
      window.localStorage.setItem('token_type', res.data.token_type)
      window.localStorage.setItem('role', res.data.role)
      window.localStorage.setItem('user', JSON.stringify(res.data.user))
      commit('authUser', {
        token: res.data.token,
        isLogin: true
      })
      commit('storeUser', res.data.user)
      EventBus.$emit("notificationCount", {id :0, admin_mail: false });
      EventBus.$emit("role", window.localStorage.getItem('role'));
      if (window.localStorage.getItem('role') == 'engineer') {
        var data = JSON.parse(window.localStorage.getItem("user"));
        var userId = data.id;
        var userToken = data.user_token;
        var firstLogin = data.first_login;
        var completedInterview = data.completed_interview;
        // if(data.nickname == null)
        // {
        //   router.replace("/engineer/nickname")
        // }
        if(firstLogin == 0)
        {
          EventBus.$emit("firstLogin",firstLogin)
          router.replace("/engineer/skill-update")
        }
        else{
          EventBus.$emit("firstLogin",firstLogin)
          EventBus.$emit("complete_interview",completedInterview)
          if (window.localStorage.getItem('URL') == undefined) {
            router.push("/engineer/profile/" + userToken)
          } else {
            router.push(window.localStorage.getItem('URL') );
          }
        }
      }
      if (window.localStorage.getItem('role') == 'company_user') {
        var data = JSON.parse(window.localStorage.getItem("user"));
        var userId = data.user_token;
        var companyId = data.company.company_token;
        if (window.localStorage.getItem('URL') == undefined) {
        router.push("/company/company-user-profile/" + companyId + "/" + userId);
        }
        else {
          router.push(window.localStorage.getItem('URL') );
        }
      }
    },

    fbLogin({commit,dispatch,state}, loading) {

      FB.getLoginStatus((response) => {
        if (response.status === 'connected') {

          FB.api('/me?fields=first_name,last_name,email,picture', (response) => {
            if(!response.email){
               EventBus.$emit("showErrorEmail", {
                email: "Email not found"
              })
              return;
            }
            const formData = {
              provider_id: response.id,
              email: response.email,
              first_name: response.first_name,
              last_name: response.last_name,

              //   profilePicture: response.pro
            }
            axios.post('/social/login', formData,{
              headers: { "X-localization": window.localStorage.getItem("lan") }})
              .then(res => {
                if (!res.data.result) {

                  } else {
                        window.localStorage.setItem('token', res.data.token)
                        window.localStorage.setItem('expires_in', res.data.expires_in)
                        window.localStorage.setItem('token_type', res.data.token_type)
                        window.localStorage.setItem('role', res.data.role)
                        window.localStorage.setItem('user', JSON.stringify(res.data.user))
                        window.localStorage.setItem('fbUser', '')
                        commit('authUser', {
                            token: res.data.token,
                            isLogin: true
                        })
                        commit('storeUser', res.data.user)
                        EventBus.$emit("notificationCount", {id :0, admin_mail: false });
                        EventBus.$emit("role", window.localStorage.getItem('role'));
                        axios.defaults.headers.common['Authorization'] = res.data.token
                        if (window.localStorage.getItem('role') == 'engineer') {
                          var data = JSON.parse(window.localStorage.getItem("user"));
                          var userId = data.id;
                          var userToken = data.user_token;
                          var firstLogin = data.first_login;
                          var completedInterview = data.completed_interview;
                          // if(data.nickname == null)
                          // {
                          //   router.replace("/engineer/nickname")
                          // }
                          if(firstLogin == 0)
                          {
                            EventBus.$emit("firstLogin",firstLogin)
                            router.replace("/engineer/skill-update")
                          }
                          else{
                            EventBus.$emit("firstLogin",firstLogin)
                            EventBus.$emit("fblogin",true);
                            EventBus.$emit("facebookloading",false);
                            EventBus.$emit("complete_interview",completedInterview)
                            if (window.localStorage.getItem('URL') == undefined) {
                              router.push("/engineer/profile/" + userToken)
                            }
                            else{
                              router.push(window.localStorage.getItem('URL') );
                            }
                          }
                        }
                    }
              })
              .catch(error => console.log(error))
          })
        }
      })
    },
    logout({commit , dispatch}) {
      return new Promise((resolve, reject) => {
      commit('clearAuthData');
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
},
  getters: {
    user(state) {
      return state.user
    },
    isAuthenticated: state => state.isLogin,
    authStatus: state => state.status,
  }
})
